import styled from '@emotion/styled'

export const Overline2 = styled.p(({ theme }) => ({
  fontFamily: theme.typography.family.default,
  fontSize: '0.5625rem',
  lineHeight: 1.33,
  fontWeight: 500,
  margin: 0,
  padding: 0,
  textTransform: 'uppercase',
  letterSpacing: '0.01em',
}))
